import React from 'react';
import Grid from '@material-ui/core/Grid';
import urlBase from '../../../url-base';
import {Link} from 'react-router';
/* import globalStyles from '../../../styles'; */
import axios from 'axios';
/* import ReactPaginate from 'react-paginate'; */


class LinkSite extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      linkSite: ''
    };

    this.styles = {
      h1: {
        fontWeight: 100,
        textAlign: 'center',
        color: '#606060',
        fontSize: 30
      },
      input: {
        width: '100%',
        height: 46,
        textAlign: 'center',
        backgroundColor: '#fff3cd',
        color: '#856404',
        fontWeight: 100,
        fontSize: 25,
        marginTop: 30,
        border: '1px solid #856404',
        cursor: 'pointer'
      }
    };
  }


  componentDidMount() {
    this.getData();
  }

  getData() {
    let url = urlBase.loopBack + 'Salesmans/?filter={"where":{"userId":"' + localStorage.getItem('dental_u') + '"}}';

    axios.get(url)
    .then((response) => {
      let state = this.state;

      state.linkSite = response.data[0].linkSite;
      this.setState(state);
    })
    .catch(function (error) {
      alert(error);
    });
  }

  render() {
    return (
      <div>
        <h1 style={this.styles.h1}>
          Compartilhe agora sua página de vendas on-line
        </h1>

        {
          this.state.linkSite.length > 0 ? (
            <div>
            <Grid container spacing={24} alignContent="center">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <label htmlFor="linkSiteInput">Link do Site:</label>

                <Link
                  to={urlBase.client + this.state.linkSite}
                  target="_blank"
                  aria-label="Acessar o link do site"
                >
                  <input
                    style={this.styles.input}
                    id="linkSiteInput"
                    type="text"
                    disabled
                    value={urlBase.client + this.state.linkSite}
                  />
                </Link>
              </Grid>
            </Grid>
  
            <Grid container spacing={24} alignContent="center"
              style={{textAlign: 'center', marginTop: 20, color:'#606060'}}>
              <Grid item xs={1} sm={1} md={1} lg={1}>
                &nbsp;
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}
                style={{cursor: 'pointer'}}>
                <i className="fas fa-share-alt fa-2x">&nbsp;</i>
              </Grid>
  
              <Grid item xs={2} sm={2} md={2} lg={2}
                style={{cursor: 'pointer'}}>
                <i className="far fa-copy fa-2x">&nbsp;</i>
              </Grid>
  
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <a
                  style={{color:"#606060"}}
                  href={"whatsapp://send?text=Acesse agora a minha página e contrate o seu plano odontológico: "+
                        urlBase.client+this.state.linkSite}
                  aria-label="Compartilhar no WhatsApp"
                >
                  <i className="fab fa-whatsapp fa-2x">&nbsp;</i>
                </a>
              </Grid>
  
              <Grid item xs={2} sm={2} md={2} lg={2}
                style={{cursor: 'pointer'}}>
                <i className="fab fa-facebook-square fa-2x">&nbsp;</i>
              </Grid>
  
              <Grid item xs={2} sm={2} md={2} lg={2}
                style={{cursor: 'pointer'}}>
                <i className="far fa-envelope fa-2x">&nbsp;</i>
              </Grid>
  
              <Grid item xs={1} sm={1} md={1} lg={1}>
                &nbsp;
              </Grid>
            </Grid>
          </div>
          ) : ('')
        }

      </div>
    );

  }

}

export default LinkSite;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/LinkSite/LinkSite.js
 **/